import { render, staticRenderFns } from "./ResendActivationDialog.vue?vue&type=template&id=b41ab188&"
import script from "./ResendActivationDialog.vue?vue&type=script&lang=js&"
export * from "./ResendActivationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports